/* eslint-disable no-return-await */
/* eslint-disable no-shadow */
import { createLogic } from 'redux-logic';

import { toastr } from 'react-redux-toastr';

import { OPERATIONS_URL } from 'utils/api';

import mock from './_mock';

import { LOAD_MENU, LOAD_OPERATIONS, UPDATE_OPERATIONS_FILTERS } from '../constants/operations';
import { normalizeMenus, normalizeOperations, normalizeOperationsFilters } from '../models/operations';
import { LoadOperationsSuccess, LoadOperationsError, LoadMenuSuccess } from '../actions/operations';

const getLengthOperations = ({ menu, submenu, operations }) => {
  const pageId = `${menu?.id}-${submenu?.id}`;
  const operationsPage = operations?.find(operationItem => operationItem?.id === pageId)?.operationsView;

  return operationsPage?.length || 0;
};

const updateMenuCount = ({ menu, menuSelectedId, operations }) => {
  const menuUptaded = menu.map(menuItem => ({
    ...menuItem,
    tiposOperacao: menuSelectedId === menuItem.id
      ? menuItem.tiposOperacao.map(submenu => ({
        ...submenu,
        title: `${submenu.descricao} (${getLengthOperations({ menu: menuItem, submenu, operations })})`,
      }))
      : menuItem.tiposOperacao,
  }));

  return menuUptaded;
};

const LoadMenuLogic = createLogic({
  type: LOAD_MENU,
  latest: true,
  process(_, dispatch, done) {
    /*  requestUtil(MENU_URL)
      .then(response => {
        if (response.error) {
          toastr.error('Tenta novamente', 'Falha ao carregar as informações');
          dispatch(LoadMenuError());
        } else {
          const normalizedMenus = normalizeMenus(response.items);
          dispatch(LoadMenuSuccess({ menus: normalizedMenus }));
        }
      })
      .then(done); */

    const normalizedMenus = normalizeMenus(mock);
    dispatch(LoadMenuSuccess({ menus: normalizedMenus }));
    done();
  },
});

const loadOperations = async (props, dispatch) => {
  const { menuSelected, tipoOperacao, requestUtil } = props;

  const url = menuSelected
    ? `${OPERATIONS_URL}/paginacao?PaginaAtual=1&?menu=${menuSelected.referenciaParametro}&tipoOperacao=${tipoOperacao.id}`
    : `${OPERATIONS_URL}/paginacao?PaginaAtual=1&`;

  // eslint-disable-next-line no-return-await
  return await requestUtil(url)
    // eslint-disable-next-line consistent-return
    .then(async (response) => {
      if (response.error) {
        toastr.error('Tenta novamente', 'Falha ao carregar as informações');
        dispatch(LoadOperationsError());
      } else {
        const { operacoes, filtro } = response;
        delete filtro.tiposOperacao;

        const normalizedOperations = await normalizeOperations(operacoes);
        const normalizedFilters = normalizeOperationsFilters(normalizedOperations);

        const id = menuSelected
          ? `${menuSelected?.id}-${tipoOperacao?.id}`
          : 'operacoes';

        return {
          id,
          operations: normalizedOperations,
          operationsView: normalizedOperations,
          filters: normalizedFilters,
        };
      }
    }).catch((error) => {
      console.error('Erro ao carregar operações:', error);
      toastr.error('Tenta novamente', 'Falha ao carregar as informações');
      dispatch(LoadOperationsError());
    });
};

const LoadOperationsLogic = createLogic({
  type: LOAD_OPERATIONS,
  latest: true,
  process({ requestUtil, action, getState }, dispatch, done) {
    const state = getState().Operation;
    const { menuSelected } = action;
    const { operations, menu } = state;

    if (menuSelected) {
      const getOperations = async () => {
        try {
          const results = await Promise.all(
            menuSelected.tiposOperacao.map(async tipoOperacao => await loadOperations({ menuSelected, tipoOperacao, requestUtil }, dispatch)),
          );

          // Filtrar resultados válidos
          const validResults = results.filter(result => result !== null && result !== undefined);

          const menuUptaded = updateMenuCount({
            menu,
            operations: validResults,
            menuSelectedId: menuSelected.id,
          });

          const operationsUptaded = [...operations.concat(validResults)];

          dispatch(LoadOperationsSuccess({
            menu: operationsUptaded.length > 0 ? menuUptaded : menu,
            operations: operationsUptaded,
          }));
        } catch (error) {
          console.error('❌ Error in getOperations:', error);
          dispatch(LoadOperationsError());
        } finally {
          done();
        }
      };

      getOperations();
    } else {
      // ... resto do código
    }
  },
});

const FilteredOperationsLogic = createLogic({
  type: UPDATE_OPERATIONS_FILTERS,
  latest: true,
  process({ action, getState }, dispatch, done) {
    const state = getState().Operation;
    const { pageId, menuId, filters } = action;
    const { operations, menu } = state;

    const getFiltersSelected = (filters, filterName) => {
      const filterType = filters?.filter(filter => filter.name === filterName)[0];
      const filtersSelected = filterType?.options.filter(filter => filter?.isSelected);
      return filtersSelected;
    };

    const applyFilter = (operations, filtersSelected, filteredField) => {
      if (filtersSelected?.length > 0) {
        return operations?.filter(operation => (
          filtersSelected?.find(filter => filter.value?.toLowerCase() === operation[filteredField]?.toLowerCase())
        ));
      }
      return operations;
    };

    const handleFilter = ({ operations, filters }) => {
      let operationsFiltered = operations;

      const assetBuy = getFiltersSelected(filters, 'papelIncluso');
      const assetsFiltered = getFiltersSelected(filters, 'ativo');
      const structuresFiltered = getFiltersSelected(filters, 'estrutura');
      const closingDateFiltered = getFiltersSelected(filters, 'encerramento');
      const categoriesFiltered = getFiltersSelected(filters, 'categoria');
      const typeStrategieFiltered = getFiltersSelected(filters, 'tipoEstrategia');

      operationsFiltered = applyFilter(operationsFiltered, assetsFiltered, 'ativoNome');
      operationsFiltered = applyFilter(operationsFiltered, assetBuy, 'mensagemCompraAtivo');
      operationsFiltered = applyFilter(operationsFiltered, categoriesFiltered, 'categoriaAtivo');
      operationsFiltered = applyFilter(operationsFiltered, structuresFiltered, 'estruturaNome');
      operationsFiltered = applyFilter(operationsFiltered, typeStrategieFiltered, 'tipoEstrategia');
      operationsFiltered = applyFilter(operationsFiltered, closingDateFiltered, 'dataEncerramentoFormatado');

      return operationsFiltered;
    };

    const operationsView = operations.filter(operationsItems => operationsItems.id === pageId)[0].operations;
    const operationsFiltered = handleFilter({ filters, operations: operationsView });

    const operationsUptaded = operations?.map((operationsItems) => {
      const update = operationsItems.id === pageId;

      return {
        ...operationsItems,
        filters: update
          ? filters
          : operationsItems.filters,
        operationsView: update
          ? operationsFiltered
          : operationsItems.operationsView,
      };
    });

    const menuUptaded = updateMenuCount({
      menu,
      menuSelectedId: menuId,
      operations: operationsUptaded,
    });

    dispatch(LoadOperationsSuccess({
      menu: menuUptaded,
      operations: operationsUptaded,
    }));

    done();
  },
});

export default [LoadMenuLogic, LoadOperationsLogic, FilteredOperationsLogic];
